'use client';

import { FC, useEffect, useId } from 'react';
import styles from './banner-lg.module.scss';
import { IProps } from 'libs/types/banner.types';

/* Скорее всего рекламный баннер */
export const BannerLG: FC<IProps> = ({ height, params, width }) => {
  const containerId = useId();

  /* Рендерится при рендеренге компанента
  * выводит каждые 40сек новую рекламу */
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const createAdfox = () => {
      if (typeof Ya === 'undefined' || !Ya?.adfoxCode) return;
      Ya.adfoxCode.create({
        ownerId: 206858,
        containerId,
        params,
      });
    };

    if (window.yaContextCb) {
      window.yaContextCb.push(createAdfox);
    } else {
      createAdfox();
    }

    const updAdFox = setInterval(() => {
      if (typeof Ya === 'undefined' || !Ya?.adfoxCode) return;
      Ya.adfoxCode.reload(containerId);
    }, 40000);

    return () => {
      clearInterval(updAdFox);
    };
  }, []);

  return <article id={containerId} className={styles.banner} style={{ height, width }} />;
};
